import PropTypes from 'prop-types';
import React from 'react';
import { localStore } from 'helpers';
import { withRouter } from 'react-router';

const withCurrentUser = Component => {
  const Container = props => {
    // let user = localStore.getItem('user') || null;
    // if (global.currentUser) {
    //   user = JSON.stringify(global.currentUser);
    // }
    // if (user) {
    //   try {
    //     user = JSON.parse(user);
    //   } catch (e) {
    //   }
    // }
    let user = {};
    const updatedProps = {
      ...props,
      currentUser: user
    };
    global.currentUser = user;
    return <Component {...updatedProps} />;
  };

  Container.propTypes = {
    currentUserQuery: PropTypes.object
  };

  return Container;
};

export default withRouter(withCurrentUser);



// WEBPACK FOOTER //
// src/modules/auth/containers/withCurrentUser.js